import React from "react";
import { colors } from "../shared/constants";

// A stepped modal. shared/SimpleModal.js only offers Cancel/Save, and both the
// campaign and the slot flows need Back/Next over a scrolling body, so the
// shell lives here rather than being hand-rolled twice.
export function WizardModal({
  title,
  subtitle,
  onClose,
  backLabel = "Close",
  onBack,
  nextLabel = "Next",
  onNext,
  nextDisabled,
  maxWidth = "640px",
  children,
}) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: colors.white,
          borderRadius: "12px",
          width: "95vw",
          maxWidth,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
        }}
      >
        <div
          style={{
            padding: "20px 24px",
            borderBottom: `1px solid ${colors.border}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ fontSize: "18px", fontWeight: "700" }}>{title}</div>
            {subtitle && (
              <div style={{ fontSize: "12px", color: colors.slate, marginTop: "2px" }}>
                {subtitle}
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#999",
            }}
          >
            ✕
          </button>
        </div>

        <div style={{ padding: "20px 24px", overflow: "auto", flex: 1 }}>{children}</div>

        <div
          style={{
            padding: "16px 24px",
            borderTop: `1px solid ${colors.border}`,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            onClick={onBack || onClose}
            style={{
              background: "none",
              border: `1px solid ${colors.border}`,
              borderRadius: "6px",
              padding: "8px 20px",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            {backLabel}
          </button>
          <button
            onClick={onNext}
            disabled={nextDisabled}
            style={{
              backgroundColor: colors.darkGrey,
              color: colors.white,
              border: "none",
              borderRadius: "6px",
              padding: "9px 20px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: nextDisabled ? "default" : "pointer",
              opacity: nextDisabled ? 0.5 : 1,
            }}
          >
            {nextLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
